import styled, { FlattenSimpleInterpolation, css } from 'styled-components'

type Props = {
    size?: number | string // TODO accept pixel by default and other scales
    weight?: number | string
    color?: string
    fontStyle?: 'normal' | 'oblique' | 'italic'
    fontFamily?: string
    /** e.g. `18px` */
    lineHeight?: string
    custom?: FlattenSimpleInterpolation
}

/**
 *  @prop color `inherit`
 *  @prop weight `default 400`
 *  @prop size   `default 14px`
 *  @prop style  `default normal`
 */
const Font = styled.span<Props>`
    ${({ size, weight, color, fontStyle, lineHeight, fontFamily, custom }) => css`
        font-size: ${size ?? 14}px;
        font-weight: ${weight ?? 400};
        font-style: ${fontStyle ?? 'normal'};
        font-family: ${fontFamily ?? 'inherit'};
        color: ${color ?? 'inherit'};
        line-height: ${lineHeight ?? 'inherit'};

        ${custom}
    `}
`
export default Font
